import React, { useState, useEffect } from "react";
import displayToastMessage from "../../../components/Common/Alert/displayToastMessage";
import Edit from "../../../assets/images/editinput.svg";
import { Select } from "@appkit4/react-components/select";

import "../../../../src/styles/userManagement.css";

import useHttp from "../../../hooks/useHttp.js";
import APIService from "../../../services/apiAxiosService.js";
import NewDateString from "../../Common/newDateString.js";


export default function Notification(props) {
  let { allOrganizations } = props;
  const [loading, setLoading] = useState(false);
  const [frequency, setFrequency] = useState("");
  const [number, setNumber] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [endDateAssessment, setEndDateAssessment] = useState("");
  const [timePeriod, setTimePeriod] = useState("");
  const { sendRequest: reminderNotification } = useHttp();
  const [errorFrequency, setErrorFrequency] = useState("");
  const [errorEndDate, setErrorEndDate] = useState("");
  const [errorEndDateAssessment, setErrorEndDateAssessment] = useState("");
  const [errortTimePeriod, setErrorTimePeriod] = useState("");
  const [selectedOrg, setSelectedOrg] = useState("");
  const [errorOrgMessage, setErrorOrgMessage] = useState("");
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();

  const [errorLastUserMessage, setErrorLastUserMessage] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);

  
  const handleSubmit = async () => {
    
    if (frequency.trim() === "") {
      setErrorFrequency("Frequency is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (endDate.trim() == "") {
      setErrorEndDate("End Date is required");
      setIsErrorMessageShown(true);
      return false;
    }

    if (timePeriod === "") {
      setErrorTimePeriod("Time Period is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (endDateAssessment.trim() == "") {
      setErrorEndDateAssessment("End Date of assessment is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (selectedOrg == "") {
      setErrorOrgMessage("Please select organization");
      setIsErrorMessageShown(true);
      return false;
    }
   
    let payload = {
      frequency: frequency,
      endDate: endDate,
      timePeriod:timePeriod,
      endDateAssessment: endDateAssessment,
      orgId:selectedOrg

    };
    try {
       reminderNotification(APIService.reminderNotification(payload), responseHandler);
    } catch (error) {
      console.log("Error", error);
      setLoading(false);
      let Msg = "Please create new reminder!";
      displayToastMessage(Msg, "error");
    }
  }

  const responseHandler = (data) => {
    if (data.CODE) {
      displayToastMessage('Notification created successfully', "success");
      setFrequency("");
      setEndDate("");
      setEndDateAssessment("");
      setTimePeriod("");
      setErrorFrequency("");
      setErrorTimePeriod("");
      setErrorEndDate("");
      setErrorEndDateAssessment("");
      setErrorOrgMessage("");
      setSelectedOrg("");
      let notifData = {
        paramuserid: Number(sessionStorage.getItem("userId")),
        paramreqid: 1,
        paramcontent: "New user created",
        paramnextroleid: 2,
        paramcreatedby: Number(sessionStorage.getItem("roleId")),
        parammsgtype: data.MSG,
      };
      handleNotificationSubmitAPI(
        APIService.handleNotificationSubmit(notifData),
        () => {}
      );
    } else {
      let Msg = "Action failed. Please try again!";
      setLoading(false);
      displayToastMessage(Msg, "error");
    }
  }

  useEffect(() => {
    let tempData = [];
    for (let i=0; i<=10; i++) {
      let data = {
        name: i.toString(),
        id: i.toString()
      }
      tempData = [...tempData, data]
    }
    setNumber(tempData);
  }, []);

  var time = [
    {
      id: "1",
      name: "1",
    },
    {
      id: "2",
      name: "2",
    },
    {
      id: "3",
      name: "3",
    },
    {
      id: "4",
      name: "4",
    },
    {
      id: "5",
      name: "5",
    },
    {
      id: "6",
      name: "6",
    },
    {
      id: "7",
      name: "7",
    },{
      id: "8",
      name: "8",
    },{
      id: "9",
      name: "9",
    },{
      id: "10",
      name: "10",
    },{
      id: "11",
      name: "11",
    },{
      id: "12",
      name: "12",
    },{
      id: "13",
      name: "13",
    },{
      id: "14",
      name: "14",
    },{
      id: "15",
      name: "15",
    },{
      id: "16",
      name: "16",
    },{
      id: "17",
      name: "17",
    },{
      id: "18",
      name: "18",
    },{
      id: "19",
      name: "19",
    },{
      id: "20",
      name: "20",
    },{
      id: "21",
      name: "21",
    },{
      id: "22",
      name: "22",
    },{
      id: "23",
      name: "23",
    },{
      id: "24",
      name: "24",
    },{
      id: "25",
      name: "25",
    },{
      id: "26",
      name: "26",
    },{
      id: "27",
      name: "27",
    },{
      id: "28",
      name: "28",
    },{
      id: "29",
      name: "29",
    },{
      id: "30",
      name: "30",
    },
  ];

 
 
  
  
  
  
  

  // handle change for frequency
  const handleFrequncy = (e) => {
   
    if(e>=0 && e<=10) {
      setFrequency(e);
      setErrorFrequency("");
    } else {
      setIsErrorMessageShown(true);
      setErrorFrequency("Special characters are not allowed");
    }
  };

  const handleChangeDate = (e) => {
    if ( e.target.value != "") {
      setEndDate(e.target.value);
      setErrorLastUserMessage("");
      setIsErrorMessageShown("");
    } else {
      setIsErrorMessageShown(true);
      setErrorLastUserMessage("Special characters are not allowed");
    }
  };

  const handleChangeDateAssessment = (e) => {
    if ( e.target.value != "") {
      setEndDateAssessment(e.target.value);
      let tempSelectedDate = new Date(e.target.value);
      let tempTodayDate = new Date();
      let tempTimeDifference = tempSelectedDate.getTime() - tempTodayDate.getTime();
      let tempDayDifference = Math.round(tempTimeDifference/(1000 * 3600 * 24));
      if (tempDayDifference >= 0 && tempDayDifference < 10) {
          setFrequency("");
          let tempData = [];
          for (let i=0; i<=tempDayDifference; i++) {
            let data = {
              name: i.toString(),
              id: i.toString()
            }
            tempData = [...tempData, data]
          }
          setNumber(tempData);
        }
        else {
          let tempData = [];
          for (let i=0; i<=10; i++) {
            let data = {
              name: i.toString(),
              id: i.toString()
            }
            tempData = [...tempData, data]
          }
          setNumber(tempData);
        }
      setErrorLastUserMessage("");
      setIsErrorMessageShown("");
    } else {
      setIsErrorMessageShown(true);
      setErrorLastUserMessage("Special characters are not allowed");
    }
  };
 
  // handle change for time period
  const handleTimePeriod = (e) => {
   
    if(e!='') {
      setTimePeriod(e);
      setErrorTimePeriod("");
    } else {
      setErrorTimePeriod("Special characters are not allowed");
    }
  };
  
  const selectOrganization = async (e) => {
    setSelectedOrg(e);
    setErrorOrgMessage("")
  
  }; 

  return (
    
        <div className="App">
          <div className="row">
              <div className="col-sm-12 mt-1">
                <div className="cv-input-field-container pt-0 pb-0">
                  <label htmlFor="Organization" className="cv-input-label">
                    Organization<span className="asterisk-required">*</span>
                  </label>
                  <Select
                    dropdownRenderMode="portal"
                    value={selectedOrg}
                    data={allOrganizations}
                    valueKey="org_id"
                    labelKey="org_name"
                    placeholder="Select organization"
                    searchable={true}
                    searchPlaceholder="Search organization"
                    showSearchOnToggle={true}
                    onSelect={(e) => selectOrganization(e)}
                    className="cv-input-field"
                  >
                  </Select>
                </div>
                <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorOrgMessage}
                </span>
              </div>
              </div>
              </div>
              <div className="row">
            <div className="col-sm-12 mt-3">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="enddatenotification" className="cv-input-label">
                What should be end date of the assessments <span className="asterisk-required">*</span>
                </label>
                <input
                            className={"cv-input-field pl-2"}
                            type="date"
                            id="enddatenotification"
                            name="NextPlannedDate"
                             value={endDateAssessment}
                            onChange={handleChangeDateAssessment}
                            min={NewDateString()}

                        />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              
           
            <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorEndDateAssessment}
                </span>
              </div>
              </div>
          </div>             
          <div className="row">
            <div className="col-sm-12 mt-3">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="frequency" className="cv-input-label">
                What should be frequency to trigger reminder notification<span className="asterisk-required">*</span>
                </label>
               
               <Select
                  className="cv-input-field"
                  dropdownRenderMode="portal"
                  searchable={true}
                  type="text"
                  value={frequency}
                  data={number}
                  valueKey="id"
                  labelKey="name"
                  showSearchOnToggle={true}
                  placeholder="Select frequency"
                  onSelect={(e) => handleFrequncy(e)}
                  name="frequency"
                ></Select>
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorFrequency}
                </span>
              </div>
            </div>
            
          </div>
          <div className="row">
            <div className="col-sm-12 mt-3">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="enddate" className="cv-input-label">
                What should be end date should be consider to automaticaliy close down the issue to pending status <span className="asterisk-required">*</span>
                </label>
                <input
                            className={"cv-input-field pl-2"}
                            type="date"
                            name="NextPlannedDate"
                             value={endDate}
                            onChange={handleChangeDate}
                            min={NewDateString()}

                        />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              
           
            <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorEndDate}
                </span>
              </div>
              </div>
          </div>
          <div className="row">
            <div className="col-sm-12 mt-3">
              <div className="cv-input-field-container pt-0 pb-0 ">
                <label htmlFor="Password" className="cv-input-label">
                From how many days from the due date should the reminder notification be triggered?<span className="asterisk-required">*</span>

                </label>
                
                    <Select
                  className="cv-input-field"
                  dropdownRenderMode="portal"
                  searchable={true}
                  type="text"
                  value={timePeriod}
                  data={time}
                  valueKey="id"
                  labelKey="name"
                  showSearchOnToggle={true}
                  placeholder="Select time period"
                  onSelect={(e) => handleTimePeriod(e)}
                  name="timePeriod"
                ></Select>
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errortTimePeriod}
                </span>
              </div>
             
            </div>
            </div>
          <div className="options-container mt-2">
            <button
              type="submit"
              className="save-button m-l-2"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
     
                )
}


